/* Scenario Studio v1: small enhancements on top of Horizon. No dependencies. */
(() => {
  const ART = window.scArt || {};
  const SEEDS = { 'prompt-tee': 42, 'latent-space-hoodie': 1337, 'seed-42-cap': 42, 'overfitted-tee': 404, 'made-with-ai-crewneck': 2048, 'generate-everything-tote': 9000, 'epoch-001-tee': 1, 'npc-energy-tee': 8, 'checkpoint-mug': 7, 'sticker-pack': 3 };
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const productCache = new Map();
  let artMode = false;
  try { artMode = localStorage.getItem('sc-render') === 'art'; } catch (e) { /* storage blocked */ }

  const handleOf = (card) => {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    const m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  };
  const seedOf = (handle) => {
    if (SEEDS[handle] != null) return SEEDS[handle];
    let h = 0;
    for (const c of handle) h = (h * 31 + c.charCodeAt(0)) % 9973;
    return h;
  };
  const mainImg = (card) => card.querySelector('.card-gallery img, img');

  const setImg = (img, src) => {
    if (!img.dataset.scSrc) {
      img.dataset.scSrc = img.getAttribute('src') || '';
      img.dataset.scSrcset = img.getAttribute('srcset') || '';
      img.dataset.scSizes = img.getAttribute('sizes') || '';
    }
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('src', src);
    if (!reduced) {
      img.classList.remove('sc-reroll-flash');
      void img.offsetWidth;
      img.classList.add('sc-reroll-flash');
    }
  };
  const restoreImg = (img) => {
    if (!img.dataset.scSrc) return;
    img.setAttribute('src', img.dataset.scSrc);
    if (img.dataset.scSrcset) img.setAttribute('srcset', img.dataset.scSrcset);
    if (img.dataset.scSizes) img.setAttribute('sizes', img.dataset.scSizes);
    img.classList.remove('sc-art-img');
  };

  const getProduct = (handle) => {
    if (!productCache.has(handle)) {
      productCache.set(handle, fetch(`${window.Shopify?.routes?.root || '/'}products/${handle}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null));
    }
    return productCache.get(handle);
  };
  const sized = (url, w) => {
    const u = url.startsWith('//') ? `https:${url}` : url;
    return u + (u.includes('?') ? '&' : '?') + `width=${w}`;
  };

  const applyArt = (card) => {
    const handle = card.dataset.scHandle;
    const img = mainImg(card);
    if (!img) return;
    if (artMode && ART[handle]) {
      setImg(img, ART[handle]);
      img.classList.add('sc-art-img');
    } else {
      restoreImg(img);
    }
  };

  const enhanceCard = (card) => {
    if (card.dataset.scDone) return;
    const handle = handleOf(card);
    if (!handle) return;
    card.dataset.scDone = '1';
    card.dataset.scHandle = handle;
    let seed = seedOf(handle);
    let index = 0;
    const pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'sc-pill';
    pill.textContent = `seed ${seed} · reroll`;
    pill.setAttribute('aria-label', `Show another view of this product, seed ${seed}`);
    pill.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();
      const product = await getProduct(handle);
      const img = mainImg(card);
      if (!product || !img || !product.images?.length) return;
      index = (index + 1) % product.images.length;
      seed += 1;
      pill.textContent = `seed ${seed} · reroll`;
      pill.setAttribute('aria-label', `Show another view of this product, seed ${seed}`);
      img.classList.remove('sc-art-img');
      setImg(img, sized(product.images[index], 800));
    });
    const host = card.querySelector('.card-gallery') || card;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    host.appendChild(pill);
    applyArt(card);
  };

  const ensureToggle = () => {
    const cards = [...document.querySelectorAll('product-card')].filter((c) => ART[c.dataset.scHandle]);
    if (!cards.length) return;
    document.querySelectorAll('.product-grid, .resource-list').forEach((grid) => {
      if (grid.previousElementSibling?.classList?.contains('sc-toggle-row')) return;
      if (!grid.querySelector('product-card')) return;
      const row = document.createElement('div');
      row.className = 'sc-toggle-row';
      row.innerHTML = '<div class="sc-toggle" role="group" aria-label="Render mode"><button type="button" data-mode="photo">RENDER: PHOTO</button><button type="button" data-mode="art">ARTWORK</button></div>';
      grid.parentNode.insertBefore(row, grid);
      row.addEventListener('click', (event) => {
        const btn = event.target.closest('button[data-mode]');
        if (!btn) return;
        artMode = btn.dataset.mode === 'art';
        try { localStorage.setItem('sc-render', artMode ? 'art' : 'photo'); } catch (e) { /* ignore */ }
        syncToggles();
        document.querySelectorAll('product-card[data-sc-handle]').forEach(applyArt);
      });
    });
    syncToggles();
  };
  const syncToggles = () => {
    document.documentElement.classList.toggle('sc-art-mode', artMode);
    document.querySelectorAll('.sc-toggle button').forEach((b) => b.setAttribute('aria-pressed', String((b.dataset.mode === 'art') === artMode)));
  };

  const enhanceAll = () => {
    document.querySelectorAll('product-card').forEach(enhanceCard);
    ensureToggle();
    const guide = document.querySelector('.size-guide-title');
    if (guide && !document.getElementById('sc-size-guide')) guide.id = 'sc-size-guide';
  };

  /* Add to cart: Generating 30/30, then In your cart */
  document.addEventListener('click', (event) => {
    const button = event.target.closest('add-to-cart-component button[name="add"]');
    if (!button || button.disabled) return;
    const label = button.querySelector('.add-to-cart-text__content span span') || button.querySelector('.add-to-cart-text__content');
    if (!label || button.dataset.scBusy) return;
    button.dataset.scBusy = '1';
    const original = label.textContent;
    button.classList.add('sc-generating');
    let step = reduced ? 30 : 0;
    label.textContent = `Generating ${step}/30`;
    const timer = setInterval(() => {
      step = Math.min(30, step + 3);
      label.textContent = `Generating ${step}/30`;
      if (step >= 30) clearInterval(timer);
    }, 40);
    const done = () => {
      clearInterval(timer);
      label.textContent = 'In your cart';
      setTimeout(() => {
        label.textContent = original;
        button.classList.remove('sc-generating');
        delete button.dataset.scBusy;
      }, 1800);
    };
    let settled = false;
    const onUpdate = () => { if (!settled) { settled = true; done(); } };
    document.addEventListener('cart:update', onUpdate, { once: true });
    setTimeout(onUpdate, 2500);
  }, true);

  /* Gift code */
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-sc-gift]');
    if (!form) return;
    event.preventDefault();
    const input = form.querySelector('input');
    const error = form.querySelector('.sc-gift__error');
    const code = (input.value || '').trim().toUpperCase();
    if (!code) {
      error.textContent = '0 credits allocated. Paste the code from your email first.';
      input.focus();
      return;
    }
    if (!/^[A-Z0-9_-]{3,40}$/.test(code)) {
      error.textContent = 'That code did not generate anything. Codes use letters, digits and dashes only.';
      input.focus();
      return;
    }
    error.textContent = '';
    const redirect = form.dataset.redirect || '/collections/all';
    window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirect)}`;
  });

  /* Footer coordinate easter egg */
  const toast = (text) => {
    let el = document.querySelector('.sc-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'sc-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = text;
    el.classList.add('is-on');
    setTimeout(() => el.classList.remove('is-on'), 2600);
  };
  document.addEventListener('click', async (event) => {
    const coord = event.target.closest('.sc-coord');
    if (!coord) return;
    const code = (coord.dataset.code || '').trim();
    const text = code || coord.textContent.trim();
    try { await navigator.clipboard.writeText(text); } catch (e) { /* clipboard refused */ }
    toast(code ? `Coordinate resolved. Code ${code} copied.` : 'Coordinate saved. You found a quiet corner of latent space.');
  });

  const start = () => {
    enhanceAll();
    const main = document.getElementById('MainContent') || document.body;
    new MutationObserver(() => enhanceAll()).observe(main, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
